<template>
    <layout-sidebar>
        <div id="mp-media-activity">
            <router-view></router-view>
        </div>
    </layout-sidebar>
</template>

<script>
    export default {
        name: "mp-media-activity"
    }
</script>

<style lang="scss">


</style>